import { createFileRoute, Outlet } from "@tanstack/react-router";
import React from "react";
import {
  Bell,
  BookOpen,
  Building2,
  CalendarDays,
  ClipboardList,
  CreditCard,
  FileCheck2,
  FileText,
  Globe,
  GraduationCap,
  History,
  LayoutDashboard,
  LifeBuoy,
  MessageSquare,
  Settings,
  ShieldCheck,
  Trash2,
  Trophy,
  UserCog,
  UserPlus,
  Users,
  Workflow,
} from "lucide-react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import type { SidebarItem } from "@/components/layout/Sidebar";
import { requireRole } from "@/lib/route-guards";

export const Route = createFileRoute("/admin")({
  beforeLoad: () => requireRole(["admin"]),
  component: AdminLayout,
});

const sidebarItems: SidebarItem[] = [
  {
    label: "Dashboard",
    path: "/admin/dashboard",
    icon: <LayoutDashboard size={20} />,
    section: "Operations",
  },
  { label: "Students", path: "/admin/students", icon: <Users size={20} />, section: "Operations" },
  { label: "Pending Onboarding", path: "/admin/onboarding", icon: <UserPlus size={20} />, section: "Operations" },
  { label: "Partners", path: "/admin/partners", icon: <Building2 size={20} />, section: "Operations" },
  {
    label: "Placements",
    path: "/admin/placements",
    icon: <Workflow size={20} />,
    section: "Operations",
  },
  { label: "Sessions", path: "/admin/sessions", icon: <CalendarDays size={20} />, section: "Delivery" },
  {
    label: "Work Logs",
    path: "/admin/work-logs",
    icon: <ClipboardList size={20} />,
    section: "Delivery",
  },
  {
    label: "Courses & Training",
    path: "/admin/courses",
    icon: <BookOpen size={20} />,
    section: "Delivery",
  },
  { label: "Seminars", path: "/admin/seminars", icon: <CalendarDays size={20} />, section: "Delivery" },
  {
    label: "Badges",
    path: "/admin/badges",
    icon: <Trophy size={20} />,
    section: "Delivery",
  },
  {
    label: "Leaderboard",
    path: "/admin/leaderboard",
    icon: <Trophy size={20} />,
    section: "Operations",
  },
  {
    label: "Tips",
    path: "/admin/tips",
    icon: <Trophy size={20} />,
    section: "Operations",
  },
  {
    label: "Certificates",
    path: "/admin/certificates",
    icon: <FileCheck2 size={20} />,
    section: "Delivery",
  },
  { label: "Reports", path: "/admin/reports", icon: <FileText size={20} />, section: "Governance" },
  { label: "Payments", path: "/admin/payments", icon: <CreditCard size={20} />, section: "Governance" },
  {
    label: "Notifications",
    path: "/admin/notifications",
    icon: <Bell size={20} />,
    section: "Governance",
  },
  {
    label: "Universities & Colleges",
    path: "/admin/institutions",
    icon: <GraduationCap size={20} />,
    section: "Governance",
  },
  { label: "Users", path: "/admin/users", icon: <UserCog size={20} />, section: "Governance" },
  {
    label: "Audit Logs",
    path: "/admin/audit-logs",
    icon: <History size={20} />,
    section: "Governance",
  },
  {
    label: "Verifications",
    path: "/admin/verifications",
    icon: <ShieldCheck size={20} />,
    section: "Governance",
  },
  { label: "Trash", path: "/admin/trash", icon: <Trash2 size={20} />, section: "Governance" },
  { label: "Feedback", path: "/admin/feedback", icon: <MessageSquare size={20} />, section: "Support" },
  {
    label: "Help & Support",
    path: "/admin/help-support",
    icon: <LifeBuoy size={20} />,
    section: "Support",
  },
  { label: "Settings", path: "/admin/settings", icon: <Settings size={20} />, section: "Support" },
  {
    label: "Website Content",
    path: "/admin/content",
    icon: <Globe size={20} />,
    section: "Support",
  },
];

function AdminLayout() {
  return (
    <DashboardLayout title="Admin Portal" sidebarItems={sidebarItems}>
      <Outlet />
    </DashboardLayout>
  );
}
